// extracted by mini-css-extract-plugin
export var adjacentSlide = "_si-9";
export var arrowButtonContainer = "_si-5";
export var arrowButtonIcon = "_si-6";
export var carouselArrowButton = "_si-2";
export var carouselElementContainer = "_si-1";
export var currentSlide = "_si-8";
export var left = "_si-3";
export var otherSlide = "_si-a";
export var productCarouselContainer = "_si-0";
export var right = "_si-4";
export var sliderOverflow = "_si-7";